export { default } from './useDeleteGeneratedReport';
